<script setup>
import { closeNewWindow, openNewWindow } from '@/libs/tools'
import { getAppleBinding, getGoogleBinding } from '@/api/user/user'
import { computed, onMounted, onUnmounted, ref } from 'vue'
import gtagTools from '@/libs/gtag-tools'
import { getSessionStorage } from '@/libs/utils'

const emits = defineEmits(['on-success'])
const props = defineProps({
  // 授权类型：auth(仅授权，比如删除账号前)/bind(绑定账号)
  authType: {
    type: String,
    default: 'bind'
  }
})

// 绑定类型：google,apple
const bindType = ref('google')
// 是否是绑定google
const isBindingGoogle = computed(() => bindType.value === 'google')

// 是否已绑定成功
let isBindingSuccess = false
/**
 * 打开绑定窗口
 * @param thirdPartyType apple/google
 */
const open = async (thirdPartyType) => {
  removeOnBindingSuccessMessage()
  window.addEventListener('message', onBindingSuccessMessage)
  bindType.value = thirdPartyType
  // 非内嵌页下先打开一个窗口，防止ajax后再打开的话火狐浏览器会阻止新窗口的打开
  const newWindow = openNewWindow(null, 'thirdPartyAuthWindow')
  isBindingSuccess = false
  // 窗口关闭时判断是否绑定成功，如果失败，并上报统计
  newWindow.onclose = () => {
    const gtagReport = isBindingGoogle.value ? gtagTools.linkGoogle : gtagTools.linkApple
    if (!isBindingSuccess) {
      gtagReport(false)
    } else {
      gtagReport(true)
    }
  }
  try {
    const getBindingUrl = isBindingGoogle.value ? getGoogleBinding : getAppleBinding
    const { data } = await getBindingUrl({ type: props.authType })
    newWindow.location = data.url
  } catch (err) {
    newWindow.close()
  }
}

// 收到父窗口绑定成功消息回调
const onBindingSuccessMessage = e => {
  const data = e.data
  if (data.action === 'accountBinding') {
    const msg = data.params.msg
    if (msg === 'success') {
      isBindingSuccess = true
      emits('on-success', bindType.value)
    }
    removeOnBindingSuccessMessage()
    setTimeout(() => {
      if (!getSessionStorage('disabledAutoCloseNewWindow')) closeNewWindow()
    }, 3000)
  }
}

const removeOnBindingSuccessMessage = () => {
  window.removeEventListener('message', onBindingSuccessMessage)
}

defineExpose({
  open
})

onMounted(() => {})

onUnmounted(() => {
  removeOnBindingSuccessMessage()
  closeNewWindow()
})
</script>

<style lang="scss" scoped></style>
